// 登陆状态
export const LOGIN_STATU = 'LOGIN_STATU'

// 退出登陆
export const LOGOUT = 'LOGOUT'

// 用户ID
export const USER_ID = 'USER_ID'

// 发送歌曲ID
export const SEND_SONGS_ID = 'SEND_SONGS_ID'

// 添加歌曲至播放列表
export const ADD_SONGS_PLAY_LIST = 'ADD_SONGS_PLAY_LIST'

// 播放专辑
export const PLAY_ALBUM = 'PLAY_ALBUM'

// 移除相应的歌曲
export const REMOVE_SONGS = 'REMOVE_SONGS'

// 清空播放列表
export const CLEAR_LIST = 'CLEAR_LIST'

// 播放历史
export const PLAY_HISTORY = 'PLAY_HISTORY'

// 歌词
export const SEND_LYRIC = 'SEND_LYRIC'

// 发送搜索建议
export const SEND_SUGGEST = 'SEND_SUGGEST'

// 上一首歌
export const PREV_SONGS = 'PREV_SONGS'

// 下一首歌
export const NEXT_SONGS = 'NEXT_SONGS'

// 播放状态
export const SET_PLAYING = 'SET_PLAYING'
